import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class TicketService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/tickets', query);
  }
  listByFilter(query?: any) {
    return this.get('/tickets-filter', query);
  }
  count(query?: any) {
    return this.get('/count-tickets', query);
  }

  create(body: any) {
    return this.post('/v2/ticket', body);
  }

  find(id) {
    return this.get('/v2/ticket/' + id);
  }

  update(id, body) {
    return this.put('/v2/ticket/' + id, body);
  }

  updateMany(query, body) {
    return this.put('/update-tickets', {
      where: query,
      data: body,
    });
  }

  status(query?: any) {
    return this.get('/status');
  }

  updateStatusCalling(body) {
    return this.put('/call-status', body);
  }

  findByCall(call_id?: any) {
    return this.get('/v2/find-ticket-mongo', { call_id: call_id });
  }

  findByQuery(query) {
    return this.get('/find-ticket/', query);
  }

  facebookSyncTicket(body?: any) {
    return this.post('/facebook-ticket', body);
  }

  ticketsByListStatus(statusList, options?: any) {
    const observableBatch = [];
    statusList.forEach(e => {
      const query = [
        {
          key: 'status',
          condition: '=',
          value: e.id,
        },
      ];
      if (options) {
        query.push(options);
      }
      observableBatch.push(
        this.get('/tickets', {
          filters: JSON.stringify(query),
        })
      );
    });

    return Observable.forkJoin(observableBatch);
  }

  merge(data) {
    return this.post('/ticket/merge', data);
  }

  mergeMany(data) {
    return this.post('/ticket/mergeMany', data);
  }

  merges(data) {
    return this.post('/v2/ticket/merges', data);
  }

  exports(query: any, body: any) {
    return this.getexcel('/v2/ticket/exports', 'DanhSachTicket', 'POST', query, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Ticket.service.ts